export function parseJwt(token: string): Record<string, any> {
    const payload = token.split('.')[1]
        .replace(/-/g, '+')
        .replace(/_/g, '/');
    return JSON.parse(decodeURIComponent(escape(atob(payload))));
}

export function isTokenExpired(token: string): boolean {
    return new Date().getTime() / 1000 > parseJwt(token).exp;
}

export function isTokenExpiringSoon(token: string, warningSeconds: number): boolean {
    const expiresAtSeconds: number = parseJwt(token).exp;
    return !!expiresAtSeconds && expiresAtSeconds - Date.now() / 1000 < warningSeconds;
}

export function secondsUntilTokenExpiry(token: string): number {
    const expiresAtSeconds: number = parseJwt(token).exp;
    return expiresAtSeconds ? Math.max(0, Math.floor(expiresAtSeconds - Date.now() / 1000)) : 0;
}
